import { useState, useCallback } from 'react';
/**
 * useSelected provides a hook interface for a generic way to select something
 * from a list, reset, apply, and cancel that selection.
 *
 * It's designed to be used with things like dropdown menus and action lists
 * where only a single item may be selected at a time.
 */
export function useSelected(defaultValue) {
    var _a = useState(defaultValue), selected = _a[0], setSelected = _a[1];
    var _b = useState(selected), active = _b[0], setActive = _b[1];
    var select = useCallback(function (item) {
        setSelected(item);
    }, []);
    var cancel = useCallback(function (onCancel) {
        setSelected(active);
        if (onCancel !== undefined)
            onCancel();
    }, [active]);
    var apply = useCallback(function (onApply) {
        setActive(selected);
        if (onApply !== undefined)
            onApply(selected);
    }, [selected]);
    return {
        /**
         * The currently selected item. Assume this is used when the user has
         * **not** applied their selection
         */
        selected: selected,
        /** Set the currently selected item */
        select: select,
        /**
         * Reset the selection back to the `lastSelectedRef` property and provide an
         * optional callback method
         */
        cancel: cancel,
        /**
         * Apply the selection to state, updating the `lastSelectedRef` property in
         * addition to the `selected` property
         */
        apply: apply,
        /**
         * The current active selection. Typically used after the user has "applied"
         * their selection as a label or title.
         */
        active: active
    };
}
//# sourceMappingURL=useSelected.js.map